<div class="lg-root">
<div class="lg-card">

  <div class="lg-left">
    <div class="lg-left-bg" aria-hidden="true"></div>

    <div class="lg-glass">
      <div class="lg-brand">
        <div class="lg-brand-icon">
          <img src="novarc-logo.png" alt="NovarcPulse" class="lg-brand-img">
        </div>
        <span class="lg-brand-name">NovarcPulse</span>
      </div>

      <div class="lg-hero">
        <p class="lg-hero-eyebrow">Enterprise HRMS Platform</p>
        <h1 class="lg-hero-title">Manage Your Workforce with <span class="lg-hero-accent">Precision.</span></h1>
        <p class="lg-hero-sub">Built for growing organisations that demand clarity, authority, and professional excellence in every workflow.</p>
      </div>
    </div>

    <div class="lg-left-foot">© {{ year }} NovarcPulse · Enterprise HR</div>
  </div>

  <div class="lg-right">
    <div class="lg-form-wrap">

      <ng-container *ngIf="currentView === 'login'">

        <div class="lg-form-header">
          <h2 class="lg-form-title">Sign In</h2>
          <p class="lg-form-sub">Access your executive dashboard to manage organizational operations.</p>
        </div>

        <div class="lg-error" *ngIf="loginError">
          <mat-icon>error_outline</mat-icon>
          <span>{{ loginError }}</span>
        </div>

        <form (ngSubmit)="login()" class="lg-form" novalidate>

          <div class="lg-field" [class.lg-field-error]="submitted && (!email || !emailValid)">
            <label class="lg-label">WORK EMAIL</label>
            <div class="lg-input-wrap">
              <mat-icon class="lg-input-icon">alternate_email</mat-icon>
              <input type="email" [(ngModel)]="email" name="email"
                     placeholder="name@company.com" class="lg-input" autocomplete="email">
            </div>
            <span class="lg-field-err" *ngIf="submitted && !email">Email is required</span>
            <span class="lg-field-err" *ngIf="submitted && email && !emailValid">Enter a valid email</span>
          </div>

          <div class="lg-field" [class.lg-field-error]="submitted && !password">
            <div class="lg-label-row">
              <label class="lg-label">PASSWORD</label>
              <a class="lg-forgot" (click)="openForgotPassword()">FORGOT PASSWORD?</a>
            </div>
            <div class="lg-input-wrap">
              <mat-icon class="lg-input-icon">lock_outline</mat-icon>
              <input [type]="hidePassword ? 'password' : 'text'" [(ngModel)]="password" name="password"
                     placeholder="••••••••" class="lg-input" autocomplete="current-password">
              <button type="button" class="lg-toggle-pw" (click)="hidePassword = !hidePassword" tabindex="-1">
                <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
            </div>
            <span class="lg-field-err" *ngIf="submitted && !password">Password is required</span>
          </div>

          <label class="lg-remember">
            <input type="checkbox" class="lg-checkbox" [(ngModel)]="rememberMe" name="rememberMe">
            <span>Remember me on this device</span>
          </label>

          <button type="submit" class="lg-submit-btn" [disabled]="loading" [class.is-loading]="loading">
            <mat-spinner *ngIf="loading" diameter="18" class="lg-btn-spinner"></mat-spinner>
            <ng-container *ngIf="!loading">
              Sign In
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </ng-container>
          </button>

          <p class="lg-contact">
            Don't have an enterprise account?
            <a class="lg-contact-link" (click)="openContactAdmin()">Contact Administration</a>
          </p>

        </form>
      </ng-container>

      <ng-container *ngIf="currentView === 'forgot'">
        <div class="lg-fp-header">
          <div class="lg-fp-icon"><mat-icon>lock_reset</mat-icon></div>
          <h2 class="lg-form-title">Reset Password</h2>
          <p class="lg-form-sub">Enter the email linked to your account and we'll send you a one-time code.</p>
        </div>

        <div class="lg-error" *ngIf="fpError">
          <mat-icon>error_outline</mat-icon><span>{{ fpError }}</span>
        </div>

        <div class="lg-form">
          <div class="lg-field" [class.lg-field-error]="fpSubmitted && fpError">
            <label class="lg-label">EMAIL ADDRESS</label>
            <div class="lg-input-wrap">
              <mat-icon class="lg-input-icon">alternate_email</mat-icon>
              <input type="email" [(ngModel)]="fpEmail" placeholder="you@company.com" class="lg-input" autocomplete="email">
            </div>
          </div>
          <button class="lg-submit-btn" (click)="sendOtp()" [disabled]="fpLoading">
            <mat-spinner *ngIf="fpLoading" diameter="18" class="lg-btn-spinner"></mat-spinner>
            <span *ngIf="!fpLoading">Send OTP</span>
          </button>
          <button class="lg-back-btn" type="button" (click)="backToLogin()">
            <mat-icon>arrow_back</mat-icon> Back to Sign In
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="currentView === 'otp'">
        <div class="lg-fp-header">
          <div class="lg-fp-icon lg-fp-icon-otp"><mat-icon>verified</mat-icon></div>
          <h2 class="lg-form-title">Check Your Email</h2>
          <p class="lg-form-sub">We sent a 6-digit code to <strong>{{ fpEmail }}</strong>. Enter it below.</p>
        </div>

        <div class="lg-error" *ngIf="fpError">
          <mat-icon>error_outline</mat-icon><span>{{ fpError }}</span>
        </div>
        <div class="lg-success" *ngIf="fpSuccess">
          <mat-icon>check_circle</mat-icon><span>{{ fpSuccess }}</span>
        </div>

        <div class="lg-form">
          <div class="lg-field">
            <label class="lg-label">ONE-TIME CODE</label>
            <div class="lg-input-wrap">
              <mat-icon class="lg-input-icon">pin</mat-icon>
              <input type="text" [(ngModel)]="fpOtp" placeholder="Enter 6-digit code"
                     class="lg-input lg-otp-input" maxlength="6" autocomplete="one-time-code" inputmode="numeric">
            </div>
          </div>
          <button class="lg-submit-btn" (click)="verifyOtp()" [disabled]="fpLoading">
            <mat-spinner *ngIf="fpLoading" diameter="18" class="lg-btn-spinner"></mat-spinner>
            <span *ngIf="!fpLoading">Verify Code</span>
          </button>
          <div class="lg-resend-row">
            <span>Didn't receive it?</span>
            <button class="lg-resend-btn" type="button" (click)="resendOtp()" [disabled]="otpResendCountdown > 0 || fpLoading">
              <ng-container *ngIf="otpResendCountdown > 0">Resend in {{ otpResendCountdown }}s</ng-container>
              <ng-container *ngIf="otpResendCountdown === 0">Resend OTP</ng-container>
            </button>
          </div>
          <button class="lg-back-btn" type="button" (click)="currentView = 'forgot'">
            <mat-icon>arrow_back</mat-icon> Change email
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="currentView === 'reset'">
        <div class="lg-fp-header">
          <div class="lg-fp-icon lg-fp-icon-reset"><mat-icon>key</mat-icon></div>
          <h2 class="lg-form-title">Create New Password</h2>
          <p class="lg-form-sub">Choose a strong password with at least 6 characters.</p>
        </div>

        <div class="lg-error" *ngIf="fpError">
          <mat-icon>error_outline</mat-icon><span>{{ fpError }}</span>
        </div>

        <div class="lg-form">
          <div class="lg-field">
            <label class="lg-label">NEW PASSWORD</label>
            <div class="lg-input-wrap">
              <mat-icon class="lg-input-icon">lock_outline</mat-icon>
              <input [type]="hideNewPw ? 'password' : 'text'" [(ngModel)]="fpNewPassword"
                     placeholder="New password" class="lg-input" autocomplete="new-password">
              <button type="button" class="lg-toggle-pw" (click)="hideNewPw = !hideNewPw" tabindex="-1">
                <mat-icon>{{ hideNewPw ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
            </div>
          </div>

          <div class="lg-field" [class.lg-field-error]="fpSubmitted && fpNewPassword !== fpConfirmPassword">
            <label class="lg-label">CONFIRM PASSWORD</label>
            <div class="lg-input-wrap">
              <mat-icon class="lg-input-icon">lock_outline</mat-icon>
              <input [type]="hideConfirmPw ? 'password' : 'text'" [(ngModel)]="fpConfirmPassword"
                     placeholder="Confirm new password" class="lg-input" autocomplete="new-password">
              <button type="button" class="lg-toggle-pw" (click)="hideConfirmPw = !hideConfirmPw" tabindex="-1">
                <mat-icon>{{ hideConfirmPw ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
            </div>
            <span class="lg-field-err" *ngIf="fpSubmitted && fpNewPassword && fpConfirmPassword && fpNewPassword !== fpConfirmPassword">
              Passwords do not match
            </span>
          </div>

          <div class="lg-strength" *ngIf="fpNewPassword">
            <div class="lg-strength-bar">
              <div class="lg-strength-fill"
                [style.width]="fpNewPassword.length < 6 ? '33%' : fpNewPassword.length < 10 ? '66%' : '100%'"
                [style.background]="fpNewPassword.length < 6 ? '#dc2626' : fpNewPassword.length < 10 ? '#c97d10' : '#166534'">
              </div>
            </div>
            <span class="lg-strength-label"
              [style.color]="fpNewPassword.length < 6 ? '#dc2626' : fpNewPassword.length < 10 ? '#c97d10' : '#166534'">
              {{ fpNewPassword.length < 6 ? 'Weak' : fpNewPassword.length < 10 ? 'Medium' : 'Strong' }}
            </span>
          </div>

          <button class="lg-submit-btn" (click)="resetPassword()" [disabled]="fpLoading">
            <mat-spinner *ngIf="fpLoading" diameter="18" class="lg-btn-spinner"></mat-spinner>
            <span *ngIf="!fpLoading">Reset Password</span>
          </button>
          <button class="lg-back-btn" type="button" (click)="backToLogin()">
            <mat-icon>arrow_back</mat-icon> Back to Sign In
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="currentView === 'contact'">
        <div class="lg-fp-header">
          <div class="lg-fp-icon"><mat-icon>support_agent</mat-icon></div>
          <h2 class="lg-fp-title">Contact Administration</h2>
          <p class="lg-fp-sub">Send a message to your IT or HR team. They'll get back to you soon.</p>
        </div>

        <ng-container *ngIf="!caSuccess">
          <div class="lg-field" [class.lg-field--error]="caSubmitted && !caName.trim()">
            <label class="lg-label">Your Name</label>
            <input class="lg-input" type="text" [(ngModel)]="caName" name="caName" placeholder="Full name" autocomplete="name">
            <span class="lg-error-msg" *ngIf="caSubmitted && !caName.trim()">Name is required</span>
          </div>

          <div class="lg-field" [class.lg-field--error]="caSubmitted && (!caEmail || caEmail.indexOf('@') < 0)">
            <label class="lg-label">Your Email</label>
            <input class="lg-input" type="email" [(ngModel)]="caEmail" name="caEmail" placeholder="your@email.com" autocomplete="email">
            <span class="lg-error-msg" *ngIf="caSubmitted && (!caEmail || caEmail.indexOf('@') < 0)">Valid email is required</span>
          </div>

          <div class="lg-field" [class.lg-field--error]="caSubmitted && caMessage.trim().length < 10">
            <label class="lg-label">Message</label>
            <textarea class="lg-input lg-textarea" [(ngModel)]="caMessage" name="caMessage" rows="4"
              placeholder="Describe your issue or request…"></textarea>
            <span class="lg-error-msg" *ngIf="caSubmitted && caMessage.trim().length < 10">Please describe your issue (min 10 characters)</span>
          </div>

          <div class="lg-error-banner" *ngIf="caError">
            <mat-icon>error_outline</mat-icon> {{ caError }}
          </div>

          <button class="lg-btn-primary" type="button" (click)="submitContactAdmin()" [disabled]="caLoading">
            <mat-progress-spinner *ngIf="caLoading" diameter="18" mode="indeterminate"></mat-progress-spinner>
            <span *ngIf="!caLoading">Send Message</span>
          </button>
        </ng-container>

        <ng-container *ngIf="caSuccess">
          <div class="lg-ca-success">
            <div class="lg-ca-success-icon"><mat-icon>check_circle</mat-icon></div>
            <h3 class="lg-ca-success-title">Message Sent</h3>
            <p class="lg-ca-success-sub">Your message has been forwarded to the administration team. Expect a response on your email shortly.</p>
          </div>
        </ng-container>

        <button class="lg-back-btn" type="button" (click)="backToLogin()">
          <mat-icon>arrow_back</mat-icon> Back to Sign In
        </button>
      </ng-container>

      <ng-container *ngIf="currentView === 'force-change'">

        <div class="fc-hero">
          <div class="fc-hero-glow"></div>
          <div class="fc-hero-icon">
            <svg viewBox="0 0 40 40" fill="none" width="22" height="22">
              <rect x="10" y="18" width="20" height="16" rx="3" stroke="white" stroke-width="2"/>
              <path d="M14 18v-5a6 6 0 0 1 12 0v5" stroke="white" stroke-width="2" stroke-linecap="round"/>
              <circle cx="20" cy="26" r="2" fill="white"/>
            </svg>
          </div>
          <div class="fc-hero-badge">Security Required</div>
          <h2 class="fc-hero-title">Set Your New Password</h2>
          <p class="fc-hero-sub">Your temporary password must be changed before you can access the platform.</p>
        </div>

        <div class="fc-steps">
          <div class="fc-step fc-step--done">
            <div class="fc-step-dot">
              <mat-icon style="font-size:11px;width:11px;height:11px;line-height:11px">check</mat-icon>
            </div>
            <span>Verified</span>
          </div>
          <div class="fc-step-line"></div>
          <div class="fc-step fc-step--active">
            <div class="fc-step-dot">2</div>
            <span>New Password</span>
          </div>
          <div class="fc-step-line"></div>
          <div class="fc-step">
            <div class="fc-step-dot">3</div>
            <span>Dashboard</span>
          </div>
        </div>

        <div class="fc-error" *ngIf="fcError">
          <mat-icon>error_outline</mat-icon><span>{{ fcError }}</span>
        </div>

        <div class="fc-fields">
          <div class="fc-field" [class.fc-field--error]="fcSubmitted && fcNewPassword.length > 0 && fcNewPassword.length < 8">
            <label class="fc-label">NEW PASSWORD</label>
            <div class="fc-input-wrap">
              <mat-icon class="fc-input-icon">lock_outline</mat-icon>
              <input [type]="hideFcNew ? 'password' : 'text'" [(ngModel)]="fcNewPassword"
                     placeholder="At least 8 characters" class="fc-input" autocomplete="new-password">
              <button type="button" class="fc-eye-btn" (click)="hideFcNew = !hideFcNew" tabindex="-1">
                <mat-icon>{{ hideFcNew ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
            </div>

            <div class="fc-strength-wrap" *ngIf="fcNewPassword">
              <div class="fc-segs">
                <div class="fc-seg" [class.fc-seg--weak]="fcNewPassword.length >= 1"
                  [class.fc-seg--medium]="fcNewPassword.length >= 8"
                  [class.fc-seg--strong]="fcNewPassword.length >= 12"></div>
                <div class="fc-seg" [class.fc-seg--weak]="fcNewPassword.length >= 4"
                  [class.fc-seg--medium]="fcNewPassword.length >= 8"
                  [class.fc-seg--strong]="fcNewPassword.length >= 12"></div>
                <div class="fc-seg" [class.fc-seg--medium]="fcNewPassword.length >= 8"
                  [class.fc-seg--strong]="fcNewPassword.length >= 12"></div>
                <div class="fc-seg" [class.fc-seg--strong]="fcNewPassword.length >= 12"></div>
              </div>
              <span class="fc-strength-lbl"
                [class.fc-sl--weak]="fcNewPassword.length < 8"
                [class.fc-sl--medium]="fcNewPassword.length >= 8 && fcNewPassword.length < 12"
                [class.fc-sl--strong]="fcNewPassword.length >= 12">
                {{ fcNewPassword.length < 4 ? 'Too short' : fcNewPassword.length < 8 ? 'Weak' : fcNewPassword.length < 12 ? 'Medium' : 'Strong' }}
              </span>
            </div>
            <span class="fc-err-msg" *ngIf="fcSubmitted && fcNewPassword.length > 0 && fcNewPassword.length < 8">
              Must be at least 8 characters
            </span>
          </div>

          <div class="fc-field" [class.fc-field--error]="fcSubmitted && fcConfirmPassword && fcNewPassword !== fcConfirmPassword">
            <label class="fc-label">CONFIRM PASSWORD</label>
            <div class="fc-input-wrap">
              <mat-icon class="fc-input-icon">lock_outline</mat-icon>
              <input [type]="hideFcConfirm ? 'password' : 'text'" [(ngModel)]="fcConfirmPassword"
                     placeholder="Repeat new password" class="fc-input" autocomplete="new-password">
              <button type="button" class="fc-eye-btn" (click)="hideFcConfirm = !hideFcConfirm" tabindex="-1">
                <mat-icon>{{ hideFcConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              <div class="fc-match-check" *ngIf="fcNewPassword && fcConfirmPassword && fcNewPassword === fcConfirmPassword">
                <mat-icon>check_circle</mat-icon>
              </div>
            </div>
            <span class="fc-err-msg" *ngIf="fcSubmitted && fcNewPassword && fcConfirmPassword && fcNewPassword !== fcConfirmPassword">
              Passwords do not match
            </span>
          </div>

          <div class="fc-rules">
            <div class="fc-rule" [class.fc-rule--ok]="fcNewPassword.length >= 8">
              <mat-icon>{{ fcNewPassword.length >= 8 ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
              <span>At least 8 characters</span>
            </div>
            <div class="fc-rule" [class.fc-rule--ok]="fcNewPassword && fcConfirmPassword && fcNewPassword === fcConfirmPassword">
              <mat-icon>{{ fcNewPassword && fcConfirmPassword && fcNewPassword === fcConfirmPassword ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
              <span>Passwords match</span>
            </div>
          </div>

          <button class="fc-submit-btn" (click)="forceChangePassword()" [disabled]="fcLoading">
            <ng-container *ngIf="fcLoading">
              <mat-spinner diameter="18" class="lg-btn-spinner"></mat-spinner>
              <span>Updating...</span>
            </ng-container>
            <ng-container *ngIf="!fcLoading">
              <svg viewBox="0 0 20 20" fill="none" width="16" height="16">
                <path d="M3 10h14M11 4l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Continue to Dashboard</span>
            </ng-container>
          </button>
        </div>

      </ng-container>

    </div>
  </div>

</div>
</div>
